import {Form, type FormData} from "@/types/permissions/forms";
import {Listing, type ListingData} from "@/types/permissions/listings";
import {Action, type ActionData} from "@/types/permissions/actions";
import {PageFilter, type PageFilterData} from "@/types/permissions/page-filters";

export class ClientPermissionPage {
    public id:number|null;
    public parent_id:number;
    public bussiness_line_id:number;
    public name:string;
    public forms: Form[];
    public listings: Listing[];
    public actions: Action[];
    public pageFilters: PageFilter[];

    constructor(data:ClientPermissionPageData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.bussiness_line_id = -1;
            this.parent_id = -1;
            this.name = '';
            this.forms = [];
            this.listings = [];
            this.actions = [];
            this.pageFilters = [];
        }
        else
        {
            this.id = data.id;
            this.bussiness_line_id = data.bussiness_line_id;
            this.parent_id = data.parent_id;
            this.name = data.name;
            this.forms = [];
            if (data.forms !== undefined) {
                data.forms.forEach(form => this.forms.push((new Form(form))));
            }

            this.listings = [];
            if (data.listings !== undefined) {
                data.listings.forEach(listing => this.listings.push((new Listing(listing))));
            }

            this.actions = [];
            if (data.actions !== undefined) {
                data.actions.forEach(action => this.actions.push((new Action(action))));
            }

            this.pageFilters = [];
            if (data.pageFilters !== undefined) {
                data.pageFilters.forEach(pageFilter => this.pageFilters.push((new PageFilter(pageFilter))));
            }
        }
    }

    public resetToDefaults():void {
        this.id = null;
        this.bussiness_line_id = -1;
        this.parent_id = -1;
        this.name = '';
        this.forms = [];
        this.pageFilters = [];
    }
}

export type ClientPermissionPageData = {
    id:number|null;
    parent_id:number;
    bussiness_line_id:number;
    name:string;
    forms: FormData[] | undefined;
    listings: ListingData[] | undefined;
    actions: ActionData[] | undefined;
    pageFilters: PageFilterData[] | undefined;
}